import { TriggerPayloadConfiguration } from './trigger-payload-configuration';
import { TriggerPayloadValidation } from './validation/trigger-payload-validation';
import { EnrolmentConfirmationChallengedTriggerPayloadValidation } from './validation/enrolment-confirmation-challenged-trigger-payload-validation';

export class EnrolmentChallengedTriggerPayloadConfiguration extends TriggerPayloadConfiguration {
	public constructor() {
		super(false, true, false, false);
	}

	public createValidation(): TriggerPayloadValidation {
		return new EnrolmentConfirmationChallengedTriggerPayloadValidation();
	}
}
